export const environment = {
  sURL: 'https://sit-api.sadmincontrol.com/v1/api/',
  bURL: 'https://sit-api.sadmincontrol.com',
  mURL: 'https://sit-market.sadmincontrol.com',
  enableSetRCsubaccount: true,
  enableDashboard: true,
  firstIndexPnl: false,
  riskCalculatorURL: 'https://sit-market.sadmincontrol.com/risk_calculator',
  betTickerURL:'https://sit-betticker',
  betTickerV1URL:'https://sit-betticker-v1',
  kjsport9URL:'https://kjs-back.pkrsrv.com/webadmin-VDX0Xj',
  casinoApiBaseUrl: 'https://sit-casino.sadmincontrol.com'

};
